(function () {
    if (window.__wishlistInit) return;
  window.__wishlistInit = true
  var STORAGE_KEY = 'wishlist_items_v1';
  var cache = {}; // in-memory product cache by handle
function wlRoot() {
  var r =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    window.__WL_ROOT__ ||
    '/';
  // ensure trailing slash
  return r.endsWith('/') ? r : (r + '/');
}

function wlProductUrl(handle) {
  return wlRoot() + 'products/' + encodeURIComponent(handle);
}

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn('Wishlist parse error', e);
      return [];
    }
  }
function safeParseWishlist() {
  try {
    var raw = window.localStorage.getItem(STORAGE_KEY);
    var parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(list) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateWishlistCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  } catch (e) {
    console.warn('Wishlist save error', e);
  }
}

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index !== -1) {
      list.splice(index, 1);
      saveWishlist(list);
    }
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) removeFromWishlist(handle);
    else addToWishlist(handle);
  }

  // ===== Money format (supports {{ amount }} and {{ amount_no_decimals }}) =====
  var moneyFormat = (typeof window.themeMoneyFormat === 'string' && window.themeMoneyFormat.length)
    ? window.themeMoneyFormat
    : '{{ amount }}';
function getWishlistI18n() {
  var el = document.getElementById('WishlistI18n');
  var d = (el && el.dataset) ? el.dataset : {};
  return {
    remove: d.removeLabel || 'Remove',
    added: d.addedLabel || 'Added',
    emptyText: d.emptyText || 'Your wishlist is empty.'
  };
}

function formatWithDelimiters(number, precision, thousands, decimal) {
  if (number == null || isNaN(number)) return '0';

  precision = precision == null ? 2 : precision;
  thousands = thousands == null ? ',' : thousands;
  decimal = decimal == null ? '.' : decimal;

  var num = (number / 100).toFixed(precision);
  var parts = num.split('.');
  var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  var cents = parts[1] ? (decimal + parts[1]) : '';
  return dollars + cents;
}

function formatMoney(cents) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = parseInt(cents, 10) || 0;

  var format = moneyFormat || '{{amount}}';
  var value = '';

  if (format.indexOf('{{amount_no_decimals_with_comma_separator}}') > -1) {
    value = formatWithDelimiters(cents, 0, '.', ',');
    return format.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, value);
  }

  if (format.indexOf('{{amount_with_comma_separator}}') > -1) {
    value = formatWithDelimiters(cents, 2, '.', ',');
    return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value);
  }

  if (format.indexOf('{{amount_no_decimals_with_space_separator}}') > -1) {
    value = formatWithDelimiters(cents, 0, ' ', '.');
    return format.replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/, value);
  }

  if (format.indexOf('{{amount_with_space_separator}}') > -1) {
    value = formatWithDelimiters(cents, 2, ' ', '.');
    return format.replace(/\{\{\s*amount_with_space_separator\s*\}\}/, value);
  }

  if (format.indexOf('{{amount_no_decimals_with_apostrophe_separator}}') > -1) {
    value = formatWithDelimiters(cents, 0, "'", '.');
    return format.replace(/\{\{\s*amount_no_decimals_with_apostrophe_separator\s*\}\}/, value);
  }

  if (format.indexOf('{{amount_with_apostrophe_separator}}') > -1) {
    value = formatWithDelimiters(cents, 2, "'", '.');
    return format.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, value);
  }

  if (format.indexOf('{{amount_no_decimals}}') > -1) {
    value = formatWithDelimiters(cents, 0, ',', '.');
    return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, value);
  }

  value = formatWithDelimiters(cents, 2, ',', '.');
  return format.replace(/\{\{\s*amount\s*\}\}/, value);
}

  // ===== Buttons state =====
  function updateButtonState(button) {
    if (!button) return;

    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var isActive = isInWishlist(handle);
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

    var img = button.querySelector('.wishlist-icon');
    if (img) {
      var inactive = button.getAttribute('data-icon-inactive');
      var active = button.getAttribute('data-icon-active');
      if (inactive && active) img.src = isActive ? active : inactive;
    }
  }

  function updateAllButtons() {
    var buttons = document.querySelectorAll('.wishlist-toggle[data-product-handle]');
    buttons.forEach(updateButtonState);
  }

function updateWishlistCount() {
  var list = safeParseWishlist();
  var hasItems = list.length > 0;

  document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
    // prevent observer feedback loop
    el.__wlUpdating = true;

    // Do not show count number anymore, only red dot state
    if (el.textContent !== '') el.textContent = '';

    el.hidden = !hasItems;
    el.classList.toggle('is-empty', !hasItems);
    el.classList.toggle('has-items', hasItems);
    el.setAttribute('aria-hidden', 'true');

    el.__wlUpdating = false;
  });
}


function syncWishlistUI() {
  initDrawerRefs();
  updateAllButtons();
  updateWishlistCount();

  if (isDrawerOpen()) renderWishlistDrawer();
}


  // ===== Product fetch with cache =====
function fetchProductByHandle(handle) {
  if (cache[handle]) return Promise.resolve(cache[handle]);

  return fetch(wlProductUrl(handle) + '.js')
    .then(function (res) { return res.json(); })
    .then(function (product) {
      cache[handle] = product;
      return product;
    });
}

  // ===== Drawer refs =====
  var drawer, drawerList, drawerEmpty, drawerSkeleton;
  // 🔒 render guards (ADD HERE)
var drawerRenderToken = 0;
var pageRenderToken = 0;

function initDrawerRefs() {
  drawer = document.getElementById('WishlistDrawer');
  drawerList = document.getElementById('WishlistDrawerList');
  drawerEmpty = document.getElementById('WishlistDrawerEmpty');
  drawerSkeleton = document.getElementById('WishlistDrawerSkeleton');
}
  // Keep wishlist count correct if header gets re-rendered
// ✅ Fast, known-stable count sync (handles header re-render + class changes)
// ✅ ONE observer only, no feedback loop
var __wlCountRaf = 0;
var __wlCountObs = null;
var __wlCountLastEl = null;

function scheduleCountSync() {
  if (__wlCountRaf) return;
  __wlCountRaf = requestAnimationFrame(function () {
    __wlCountRaf = 0;
    updateWishlistCount();
  });
}

function watchWishlistCountBadge() {
  var badge = document.querySelector('[data-wishlist-count]');
  if (!badge) return;

  // If it's the same element, don't reattach
  if (badge === __wlCountLastEl && __wlCountObs) return;

  // New badge element (header re-render), clean up old observer
  if (__wlCountObs) __wlCountObs.disconnect();

  __wlCountLastEl = badge;

  __wlCountObs = new MutationObserver(function (mutations) {
    // Ignore mutations caused by our own count update
    if (badge.__wlUpdating) return;

    // If theme script tries to hide/empty it, restore next frame
    scheduleCountSync();
  });

  __wlCountObs.observe(badge, {
    attributes: true,
    attributeFilter: ['class', 'hidden', 'style']
  });

  // Ensure correct once after attaching
  scheduleCountSync();
}

// Watch once DOM is ready, and also after Shopify re-renders sections
document.addEventListener('DOMContentLoaded', function () {
  watchWishlistCountBadge();
  scheduleCountSync();
});

document.addEventListener('shopify:section:load', function () {
  watchWishlistCountBadge();
  scheduleCountSync();
});

  function isDrawerOpen() {
    return drawer && drawer.classList.contains('is-open');
  }

function openDrawer() {
  if (!drawer) return;

  renderWishlistDrawer();

  drawer.hidden = false;

  requestAnimationFrame(function () {
    drawer.classList.add('is-open');
    document.documentElement.classList.add('wishlist-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
  });
}

function closeDrawer() {
  if (!drawer) return;

  drawer.classList.remove('is-open');
  document.documentElement.classList.remove('wishlist-drawer-open');
  drawer.setAttribute('aria-hidden', 'true');
}

function createDrawerItem(product) {
  var item = document.createElement('div');
  item.className = 'wishlist-drawer__item';

  var productUrl = wlProductUrl(product.handle);

  var imageLink = document.createElement('a');
  imageLink.href = productUrl;
  imageLink.className = 'wishlist-drawer__thumb';
  imageLink.setAttribute('aria-label', product.title || 'View product');

  if (product.featured_image) {
    var img = document.createElement('img');
    img.src = product.featured_image;
    img.alt = product.title || '';
    img.loading = 'lazy';
    imageLink.appendChild(img);
  }

  var info = document.createElement('div');
  info.className = 'wishlist-drawer__info';

  var titleLink = document.createElement('a');
  titleLink.href = productUrl;
  titleLink.className = 'wishlist-drawer__titlelink';
  titleLink.textContent = product.title || '';

  var vendor = document.createElement('div');
  vendor.className = 'wishlist-drawer__vendor';
  vendor.textContent = product.vendor || '';

  var viewMore = document.createElement('a');
  viewMore.href = productUrl;
  viewMore.className = 'wishlist-drawer__view-more';
  viewMore.textContent = 'View More';

  var removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'wishlist-toggle wishlist-drawer__remove';
  removeBtn.setAttribute('data-product-handle', product.handle);
  removeBtn.setAttribute('aria-pressed', 'true');
  removeBtn.textContent = getWishlistI18n().remove || 'Remove';

  info.appendChild(titleLink);

  if (product.vendor) {
    info.appendChild(vendor);
  }

  info.appendChild(viewMore);

  item.appendChild(imageLink);
  item.appendChild(info);
  item.appendChild(removeBtn);

  return item;
}

function renderWishlistDrawer() {
  if (!drawerList || !drawerEmpty) return;

  var token = ++drawerRenderToken;
  var handles = getWishlist();

  drawerList.innerHTML = '';

  if (drawerSkeleton) {
    drawerSkeleton.hidden = true;
  }

  if (!handles.length) {
    drawerEmpty.hidden = false;
    return;
  }

  drawerEmpty.hidden = true;

  if (drawerSkeleton) {
    drawerSkeleton.hidden = false;
  }

  Promise.all(handles.map(fetchProductByHandle))
    .then(function (products) {
      if (token !== drawerRenderToken) return;

      if (drawerSkeleton) {
        drawerSkeleton.hidden = true;
      }

      drawerList.innerHTML = '';

      products
        .filter(Boolean)
        .forEach(function (product) {
          drawerList.appendChild(createDrawerItem(product));
        });

      if (!drawerList.children.length) {
        drawerEmpty.hidden = false;
      }
    })
    .catch(function (err) {
      if (drawerSkeleton) {
        drawerSkeleton.hidden = true;
      }

      drawerEmpty.hidden = false;
      console.error('Error rendering wishlist drawer', err);
    });
}

  // ===== Wishlist page renderer =====
function renderWishlistPage() {
  var grid = document.getElementById('WishlistGrid');
  var empty = document.getElementById('WishlistEmpty');
  if (!grid || !empty) return;

  var token = ++pageRenderToken;
  var handles = getWishlist();

  grid.innerHTML = '';

  if (!handles.length) {
    empty.hidden = false;
    return;
  }

  empty.hidden = true;

  Promise.all(handles.map(fetchProductByHandle))
    .then(function (products) {
      if (token !== pageRenderToken) return; // ignore stale render
      products.forEach(function (product) {
        grid.appendChild(createWishlistCard(product));
      });
    })
    .catch(function (err) {
      console.error('Error rendering wishlist page', err);
    });
}

  function createWishlistCard(product) {
    var article = document.createElement('article');
    article.className = 'wishlist-card';

    var link = document.createElement('a');
link.href = wlProductUrl(product.handle);
    link.className = 'wishlist-card-img';

    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image;
      img.alt = product.title;
      img.loading = 'lazy';
      link.appendChild(img);
    }

    var info = document.createElement('div');
    info.className = 'wishlist-card-info';

    var titleLink = document.createElement('a');
titleLink.href = wlProductUrl(product.handle);
    titleLink.className = 'wishlist-card-title';
    titleLink.textContent = product.title;

    var priceDiv = document.createElement('div');
    priceDiv.className = 'wishlist-card-price';
    priceDiv.innerHTML = formatMoney(product.price);

    var actions = document.createElement('div');
    actions.className = 'wishlist-card-actions';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-toggle is-active wishlist-remove';
    btn.setAttribute('data-product-handle', product.handle);
    btn.setAttribute('aria-pressed', 'true');
    btn.textContent = getWishlistI18n().remove;

    actions.appendChild(btn);

    info.appendChild(titleLink);
    info.appendChild(priceDiv);
    info.appendChild(actions);

    article.appendChild(link);
    article.appendChild(info);

    return article;
  }

// ===== Events =====
function bindEvents() {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.wishlist-toggle[data-product-handle]');
    if (btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      toggleWishlist(handle);
      return;
    }

    var openTrigger = event.target.closest('[data-wishlist-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer();
      return;
    }

    var closeTrigger = event.target.closest('[data-wishlist-close]');
    if (closeTrigger) {
      closeDrawer();
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isDrawerOpen()) closeDrawer();
  });
}

// Update UI when wishlist changes (single source of truth)
document.addEventListener('wishlist:updated', function (e) {
  var list = e && e.detail && Array.isArray(e.detail.list) ? e.detail.list : safeParseWishlist();

  initDrawerRefs();
if (document.querySelector('.wishlist-toggle[data-product-handle]')) updateAllButtons();
  updateWishlistCount();

  if (isDrawerOpen()) renderWishlistDrawer();
});

// Theme editor / section re-render
document.addEventListener('shopify:section:load', function () {
  initDrawerRefs();
if (document.querySelector('.wishlist-toggle[data-product-handle]')) updateAllButtons();
  updateWishlistCount();
});

// Back/forward cache restore
window.addEventListener('pageshow', function () {
  initDrawerRefs();
if (document.querySelector('.wishlist-toggle[data-product-handle]')) updateAllButtons();
  updateWishlistCount();
});

document.addEventListener('DOMContentLoaded', function () {
  bindEvents();
  initDrawerRefs();
if (document.querySelector('.wishlist-toggle[data-product-handle]')) updateAllButtons();
  updateWishlistCount();
});

  // Optional: expose minimal API
  window.WishlistStore = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist,
    openDrawer: openDrawer
  };

})();
